import React from 'react'

import {FieldEditableValueNotEmptyProps} from "../../../../../proto/components/editable/value-not-empty"

export default function FieldDateRange_ControlViewEmpty(props:FieldEditableValueNotEmptyProps) {

    const classes = Classes("ui5-control-button s-28 hover-bg p-l-6 p-r-6", props.className, {
        "disabled": props.disabled
    })

    return (
        <>
            <div className={classes} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                <div className="ui5-txt-not-important-small lh-13em w-100-percent">
                    {props.field.placeholder}
                </div>
            </div>
            {props.children}
        </>
    )

}

